import HighLightEmbed from '@anm/components/HighlightEmbed';
import { FC } from 'react';

import { EmbedItemProps } from '..';

import { PreviewLine, Wrapper } from './Wrapper';

const defaultPlaceholderSrc = `images/dashboard/empty_poster.svg`;

const HighLightEmbedPreview: FC<EmbedItemProps> = ({ hostId, embedData, isNoVideo, videoName }) => {
  const { sizes, popover } = embedData;

  const imgSrc = isNoVideo ? defaultPlaceholderSrc : popover.thumbSrc;

  return (
    <PreviewLine>
      <Wrapper>
        <HighLightEmbed {...{ sizes, hostId, imgSrc, videoName }} title={popover.text} />
      </Wrapper>
    </PreviewLine>
  );
};

export default HighLightEmbedPreview;
